import React, { useState, useEffect } from "react";
import logo from "../../Assets/Images/profile_Pic.png";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaPinterestP,
} from "react-icons/fa";
import { IoLinkOutline } from "react-icons/io5";

const BlogImageHeading = ({ blogData }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1500);
    return () => clearTimeout(timer);
  }, []);

  if (!blogData) return null;

  // Format date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleDateString("en-US", { month: "long" });
    const year = date.getFullYear();
    return { date: day.toString(), month, year: year.toString() };
  };

  const formattedDate = formatDate(blogData.createdAt);

  return (
    <div className="w-full px-4 md:px-10">
      <div className="border-b-2 w-full xl:w-[872px] grid gap-4">
        {loading ? (
          /* Skeleton Loader */
          <div className="animate-pulse w-full xl:w-[872px] grid gap-4">
            {/* title skeleton */}
            <div className="h-8 bg-gray-300 rounded w-3/4"></div>

            {/* user info skeleton */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 py-4">
              {/* left side */}
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-gray-300"></div>
                <div className="space-y-2">
                  <div className="h-4 bg-gray-300 rounded w-32"></div>
                  <div className="h-3 bg-gray-300 rounded w-24"></div>
                </div>
              </div>
              {/* right side (social icons skeleton) */}
              <div className="flex gap-4 justify-start md:justify-end">
                {Array(5)
                  .fill(0)
                  .map((_, i) => (
                    <div
                      key={i}
                      className="w-8 h-8 bg-gray-300 rounded-full"
                    ></div>
                  ))}
              </div>
            </div>
          </div>
        ) : (
          <>
            {/* paragraph */}
            <div className="py-2">
              <p className="font-medium text-lg md:text-[32px]">
                {blogData.title}
              </p>
            </div>

            {/* user info */}
            <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-4 py-2 md:py-6">
              {/* left side */}
              <div className="flex items-start gap-4">
                {/* user image */}
                <img src={logo} alt="User" className="w-12 h-12 rounded-full" />

                {/* user name & info */}
                <div>
                  <p className="font-medium text-md text-[#1A1A1A]">
                    {blogData.author}
                  </p>
                  <div className="flex items-center gap-2 text-sm text-[#808080]">
                    <p>
                      {formattedDate.date} {formattedDate.month},{" "}
                      {formattedDate.year}
                    </p>
                    <span>•</span>
                    <p>6 min read</p>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default BlogImageHeading;
